import React from "react";
import Banner from "../components/Banner/Banner.js";
import CoinsTable from "../components/CoinsTable.js";

export default function HomePage() {
  return (
    <>
      <Banner />
      <CoinsTable />
    </>
  );
}
